'use client'

import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'

/**
 * Soft premium editor backdrop — light canvas, does not affect blocks.
 */
export default function NotebookAtmosphere() {
  const rootRef = useRef(null)

  useEffect(() => {
    const root = rootRef.current
    if (!root) return

    const orbs = root.querySelectorAll('[data-orb]')
    const ctx = gsap.context(() => {
      orbs.forEach((orb, i) => {
        gsap.to(orb, {
          x: 'random(-20, 20)',
          y: 'random(-14, 14)',
          duration: 'random(18, 26)',
          ease: 'sine.inOut',
          repeat: -1,
          yoyo: true,
          delay: i * 0.7,
        })
      })
    }, root)

    return () => ctx.revert()
  }, [])

  return (
    <div ref={rootRef} className="nb-editor-atmosphere" aria-hidden>
      <div className="nb-editor-atmosphere__base" />
      <div className="nb-editor-atmosphere__orb nb-editor-atmosphere__orb--a" data-orb />
      <div className="nb-editor-atmosphere__orb nb-editor-atmosphere__orb--b" data-orb />
      <div className="nb-editor-atmosphere__vignette" />
      <div className="nb-editor-atmosphere__grain" />
    </div>
  )
}
